export const environment = {
	production: true,
	firebaseConfig: {
		apiKey: 'AIzaSyAnTrhlFHG3S0NLd8N_lbQoeanwguQgSZg',
		authDomain: 'hubble-prod-dcbd4.firebaseapp.com',
		projectId: 'hubble-prod-dcbd4',
		storageBucket: 'hubble-prod-dcbd4.appspot.com',
		messagingSenderId: '449220924469',
		appId: '1:449220924469:web:765fe3993298bd7dc3cd7c',
		measurementId: 'G-NQBTLEEN2D',
	},
	url: {
		profile: 'https://jobs.terra.do/profile',
		hubble: 'https://api.terra.do/stage/hubble',
		cohort: 'https://cohort.terra.do/cohort',
		class: 'https://api.terra.do/beta/class',
		company: 'https://jobs.terra.do/portfolio',
		catalog: 'https://cohort.terra.do/catalog',
		onboarding: 'https://welcome.terra.do/on_boarding_done',
		lookupBaseUrl:
			'https://hubble-lookup-service-dot-hubble-prod-dcbd4.uc.r.appspot.com/',
		feedBaseUrl: 'https://hubble-prod-dcbd4.uc.r.appspot.com/api/',
		joinHubbleEvent: 'https://app.terra.do/join/hubbleEvent/',
	},
	specialFair: 85,
};
